// extracted by mini-css-extract-plugin
export default {"mdrTextArea":"TextArea_mdrTextArea__HoQks"};